// This module expects to receive a jsconn object
// it process the messages and returns the jsconn object unchanged

import store from '../../store'

const processMessages = (jsConn) => {
  // is the response in the response or error property?
  if (jsConn.apiCallStatus === 'success') {
    // the api call was a success
    const messages = jsConn.response['data']['messages'] ? jsConn.response['data']['messages'] : []

    store.dispatch('loadNotificationItems', messages)
  }

  return Promise.resolve(jsConn)
}

export { processMessages }
